import { useCallback, useEffect, useState } from 'react';
import { IssueService } from '../../services/issue/issueService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage Issues fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de incidencias.
----------------------------------------------------------------------------------------*/

const useIssuesStatus = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999, 
        filter_filters: { ...initialFilters } 
    });

    const fetchIssuesStatus = useCallback(async () => {
        try {
            const service = new IssueService();
            const response = await service.listForSelectStatus({ limit: 999999 });
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; color: string; }) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching windTurbines:', error);
        }
    }, []);

    useEffect(() => {
        fetchIssuesStatus();
    }, []);

    const getIssuesStatusList = () => {
        return data;
    };

    return { fetchIssuesStatus, getIssuesStatusList };
}

export default useIssuesStatus;